/* eslint-disable camelcase */
export const careerStatusOptions = [
	{
		id: 'student',
		title: 'Student (< 1 Years of Experience)',
		value: 'Student',
	},
	{
		id: 'early_career',
		title: 'Early Career (1-7 Years of Experience)',
		value: 'Early Career',
	},
	{
		id: 'working_professional',
		title: 'Professional (7+ Years of Experience)',
		value: 'Working Professional',
	},
	{
		id: 'not_working',
		title: 'Not Working',
		value: 'Not Working',
	},
];

export const stuckAtOptions = [
	{
		title: 'I need help with my resume',
		value: 'resume',
	},
	{
		title: 'I need help with my cover letter',
		value: 'cover-letter',
	},
	{
		title: 'I need help with networking',
		value: 'networking',
	},
	{
		title: 'I need help with practicing interviews',
		value: 'interviews',
	},
	{
		title: 'I need help with finding the right jobs ',
		value: 'findJobs',
	},
	{
		title: 'I need help with tracking my applications ',
		value: 'applicationsTracking',
	},
	{
		title: 'I don\'t know where to start',
		value: 'na',
	},
];

export const leadSourceOptions = [
	{
		title: 'Jerry’s social media',
		value: 'Jerry',
	},
	{
		title: 'Jonathan’s social media',
		value: 'Jonathan',
	},
	{
		title: 'Instagram',
		value: 'instagram',
	},
	{
		title: 'TikTok',
		value: 'TikTok',
	},
	{
		title: 'Youtube / Other Social Media',
		value: 'youtubeOrOther',
	},
	{
		title: 'Google Search / Google Ad',
		value: 'googleOrGoogleAd',
	},
	{
		title: 'ChatGPT / AI Tools',
		value: 'llm',
	},
	{
		title: 'Word of Mouth / Referral',
		value: 'wordOfMouthOrReferral',
	},
	{
		title: 'Other',
		value: 'other',
	},

];

export const AA_ONBOARDING_STEPS = {
	one: {
		title: 'Welcome to AutoApply!',
		description:
            'AutoApply is designed to help you apply to jobs at scale, with a few clicks',
	},
	two: {
		title: 'Will recruiters know?',
		description:
            "Rest assured, we have a built-in system that mimics manual job application processes so companies will never know that you've used AutoApply to submit job applications.",
	},
	three: {
		title: 'Is my data protected?',
		description:
            'AutoApply takes your privacy seriously. We will only use the information you share with us for the purpose of applying to jobs on your behalf.',
	},
	four: {
		title: 'Getting Started',
		description:
            'Now that you know what AutoApply is, we’ll need some information to get you started!',
	},
	information: {
		title: 'Fill in your information',
		description:
            'These fields are required in job applications. Your information will not be used for any other purposes.',
	},
	review: {
		title: 'Review your information',
		description: 'Please ensure all the information below is correct.',
	},
	allowAnswering: {
		title: '',
		description: '',
	},
	done: {
		title: 'You’re all set!',
		description:
            "Now that we have your basic info, let's create an application. Are you ready to take your job search to the next level?",
	},
};

export const first_gen_student_options = [
	{
		id: 1,
		title: 'Yes',
		value: true,
	}, {
		id: 0,
		title: 'No',
		value: false,
	}
];

export const non_target_school_options = [
	{
		id: 11,
		title: 'Yes',
		value: true,
	}, {
		id: 10,
		title: 'No',
		value: false,
	}
];

export const industry_options = [
	'Hospital and Health Care',
	'Construction',
	'Retail',
	'Education Management',
	'Financial Services',
	'Accounting',
	'Computer Software',
	'Higher Education',
	'Automotive',
	'Government Administration',
	'Marketing and Advertising',
	'Banking',
	'Health, Wellness and Fitness',
	'Real Estate',
	'Food and Beverages',
	'Telecommunications',
	'Oil and Energy',
	'Hospitality',
	'Mechanical or Industrial Engineering',
	'Primary/Secondary Education',
	'Internet',
	'Electrical/Electronic Manufacturing',
	'Insurance',
	'Medical Practice',
	'Human Resources',
	'Consumer Services',
	'Transportation/Trucking/Railroad',
	'Pharmaceuticals',
	'Restaurants',
	'Management Consulting',
	'Civil Engineering',
	'Research',
	'Design',
	'Logistics and Supply Chain',
	'Law Practice',
	'Architecture and Planning',
	'Apparel and Fashion',
	'Consumer Goods',
	'Facilities Services',
	'Food Production',
	'Non-Profit Organization Management',
	'Machinery',
	'Entertainment',
	'Chemicals',
	'Wholesale',
	'Arts and Crafts',
	'Utilities',
	'Farming',
	'Legal Services',
	'Mining and Metals',
	'Airlines/Aviation',
	'Leisure, Travel and Tourism',
	'Sports',
	'Building Materials',
	'Environmental Services',
	'Professional Training and Coaching',
	'Medical Devices',
	'Music',
	'Individual and Family Services',
	'Cosmetics',
	'Mental Health Care',
	'Industrial Automation',
	'Security and Investigations',
	'Staffing and Recruiting',
	'Aviation and Aerospace',
	'Graphic Design',
	'Biotechnology',
	'Textiles',
	'Import and Export',
	'Consumer Electronics',
	'Public Relations and Communications',
	'Broadcast Media',
	'Business Supplies and Equipment',
	'Writing and Editing',
	'Military',
	'Media Production',
	'Computer Networking',
	'International Trade and Development',
	'Renewables and Environment',
	'Events Services',
	'Civic and Social Organization',
	'Photography',
	'Computer Hardware',
	'Defense and Space',
	'Furniture',
	'Computer and Network Security',
	'Printing',
	'Fine Art',
	'Investment Management',
	'E-Learning',
	'Outsourcing/Offshoring',
	'Warehousing',
	'Law Enforcement',
	'Publishing',
	'Religious Institutions',
	'Maritime',
	'Information Services',
	'Supermarkets',
	'Executive Office',
	'Animation',
	'Government Relations',
	'Semiconductors',
	'Program Development',
	'Plastics',
	'Online Media',
	'Public Safety',
	'Packaging and Containers',
	'Judiciary',
	'Alternative Medicine',
	'Performing Arts',
	'Commercial Real Estate',
	'Motion Pictures and Film',
	'Veterinary',
	'Computer Games',
	'Luxury Goods and Jewelry',
	'International Affairs',
	'Investment Banking',
	'Market Research',
	'Wine and Spirits',
	'Package/Freight Delivery',
	'Newspapers',
	'Translation and Localization',
	'Recreational Facilities and Services',
	'Sporting Goods',
	'Public Policy',
	'Capital Markets',
	'Paper and Forest Products',
	'Libraries',
	'Wireless',
	'Venture Capital and Private Equity',
	'Gambling and Casinos',
	'Ranching',
	'Glass, Ceramics and Concrete',
	'Philanthropy',
	'Dairy',
	'Museums and Institutions',
	'Shipbuilding',
	'Think Tanks',
	'Political Organization',
	'Fishery',
	'Fund-Raising',
	'Tobacco',
	'Railroad Manufacture',
	'Alternative Dispute Resolution',
	'Nanotechnology',
	'Legislative Office',
	'Mobile Games',
	'Other (please specify)'
];

export const education_institutions_options = [
	'Hospital & Health Care',
	'Construction',
	'Retail',
	'Education Management',
	'Financial Services',
	'Accounting',
	'Computer Software',
	'Higher Education',
	'Automotive',
	'Government Administration',
	'Marketing and Advertising',
	'Banking',
	'Health, Wellness and Fitness',
	'Real Estate',
	'Food & Beverages',
	'Telecommunications',
	'Oil & Energy',
	'Hospitality',
	'Mechanical or Industrial Engineering',
	'Primary/Secondary Education',
	'Internet',
	'Electrical/Electronic Manufacturing',
	'Insurance',
	'Medical Practice',
	'Human Resources',
	'Consumer Services',
	'Transportation/Trucking/Railroad',
	'Pharmaceuticals',
	'Restaurants',
	'Management Consulting',
	'Civil Engineering',
	'Research',
	'Design',
	'Logistics and Supply Chain',
	'Law Practice',
	'Architecture & Planning',
	'Apparel & Fashion',
	'Consumer Goods',
	'Facilities Services',
	'Food Production',
	'Non-Profit Organization Management',
	'Machinery',
	'Entertainment',
	'Chemicals',
	'Wholesale',
	'Arts and Crafts',
	'Utilities',
	'Farming',
	'Legal Services',
	'Mining & Metals',
	'Airlines/Aviation',
	'Leisure, Travel & Tourism',
	'Sports',
	'Building Materials',
	'Environmental Services',
	'Professional Training & Coaching',
	'Medical Devices',
	'Music',
	'Individual & Family Services',
	'Cosmetics',
	'Mental Health Care',
	'Industrial Automation',
	'Security and Investigations',
	'Staffing and Recruiting',
	'Aviation & Aerospace',
	'Graphic Design',
	'Biotechnology',
	'Textiles',
	'Import and Export',
	'Consumer Electronics',
	'Public Relations and Communications',
	'Broadcast Media',
	'Business Supplies and Equipment',
	'Writing and Editing',
	'Military',
	'Media Production',
	'Computer Networking',
	'International Trade and Development',
	'Renewables & Environment',
	'Events Services',
	'Civic & Social Organization',
	'Photography',
	'Computer Hardware',
	'Defense & Space',
	'Furniture',
	'Computer & Network Security',
	'Printing',
	'Fine Art',
	'Investment Management',
	'E-Learning',
	'Outsourcing/Offshoring',
	'Warehousing',
	'Law Enforcement',
	'Publishing',
	'Religious Institutions',
	'Maritime',
	'Information Services',
	'Supermarkets',
	'Executive Office',
	'Animation',
	'Government Relations',
	'Semiconductors',
	'Program Development',
	'Plastics',
	'Online Media',
	'Public Safety',
	'Packaging and Containers',
	'Judiciary',
	'Alternative Medicine',
	'Performing Arts',
	'Commercial Real Estate',
	'Motion Pictures and Film',
	'Veterinary',
	'Computer Games',
	'Luxury Goods & Jewelry',
	'International Affairs',
	'Investment Banking',
	'Market Research',
	'Wine and Spirits',
	'Package/Freight Delivery',
	'Newspapers',
	'Translation and Localization',
	'Recreational Facilities and Services',
	'Sporting Goods',
	'Public Policy',
	'Capital Markets',
	'Paper & Forest Products',
	'Libraries',
	'Wireless',
	'Venture Capital & Private Equity',
	'Gambling & Casinos',
	'Ranching',
	'Glass, Ceramics & Concrete',
	'Philanthropy',
	'Dairy',
	'Museums and Institutions',
	'Shipbuilding',
	'Think Tanks',
	'Political Organization',
	'Fishery',
	'Fund-Raising',
	'Tobacco',
	'Railroad Manufacture',
	'Alternative Dispute Resolution',
	'Nanotechnology',
	'Legislative Office',
	'Mobile Games',
	'Other (please specify)'
];

export const undergraduate_degree_options = ['Bachelor of Applied Arts (BAA)','Bachelor of Applied Science (BASc)','Bachelor of Architecture (BArch)','Bachelor of Arts (BA)','Bachelor of Business Administration (BBA)','Bachelor of Education (BEd)','Bachelor of Engineering (BEng)','Bachelor of Fine Arts (BFA)','Bachelor of Music (BM)','Bachelor of Science (BS)','Bachelor of Science in Accessory Design (BSAcDes)','Bachelor of Science in Accounting (BSA)','Bachelor of Science in Accounting (BSAcc)','Bachelor of Science in Actuarial Science (BSActSci)','Bachelor of Science in Agricultural Science (BSAS)','Bachelor of Science in Anthropology (BSAnth)','Bachelor of Science in Applied Economics (BSAppEcon)','Bachelor of Science in Architecture Design (BSArchDes)','Bachelor of Science in Art Education (BSArtEd)','Bachelor of Science in Art History (BSArtHist)','Bachelor of Science in Athletic Training (BSAT)','Bachelor of Science in Audio Production (BSAP)','Bachelor of Science in Audiology (BSAud)','Bachelor of Science in Biological Science (BSBio)','Bachelor of Science in Business (BSB)','Bachelor of Science in Business Analytics (BSBA)','Bachelor of Science in Business and Technology (BSBT)','Bachelor of Science in Business Data Analytics (BSBDA)','Bachelor of Science in Business Data Science (BSBDS)','Bachelor of Science in Business Economics (BSBE)','Bachelor of Science in Business Intelligence (BSBI)','Bachelor of Science in Business Intelligence and Analytics (BSBIA)','Bachelor of Science in Business Management (BSBM)','Bachelor of Science in Business Operations Management (BSBOM)','Bachelor of Science in Business Process Management (BSBPM)','Bachelor of Science in Business Supply Chain Management (BSBSCM)','Bachelor of Science in Business Technology (BSBT)','Bachelor of Science in Chemistry (BSChem)','Bachelor of Science in Communications (BSComm)','Bachelor of Science in Computer Information Systems (BSCIS)','Bachelor of Science in Computer Science (BSCS)','Bachelor of Science in Costume Design (BSCostDes)','Bachelor of Science in Criminology (BSCrim)','Bachelor of Science in Dance (BSDance)','Bachelor of Science in Data Analytics (BSDA)','Bachelor of Science in Data Science (BSDS)','Bachelor of Science in Dietetics (BSDiet)','Bachelor of Science in Drama Education (BSDramaEd)','Bachelor of Science in E-Commerce (BSEcom)','Bachelor of Science in Early Childhood Education (BSECE)','Bachelor of Science in Economics (BSEcon)','Bachelor of Science in Education (BSEd)','Bachelor of Science in Elementary Education (BSElemEd)','Bachelor of Science in Engineering Technology (BSET)','Bachelor of Science in Entrepreneurship (BSEntrep)','Bachelor of Science in Environmental Science (BSES)','Bachelor of Science in Environmental Studies (BSEnvSt)','Bachelor of Science in Exercise Science (BSExSci)','Bachelor of Science in Fashion Design (BSFDes)','Bachelor of Science in Film Studies (BSFilm)','Bachelor of Science in Finance (BSF)','Bachelor of Science in Financial Economics (BSFinEcon)','Bachelor of Science in Financial Mathematics (BSFinMath)','Bachelor of Science in Foreign Language Education (BSFLEd)','Bachelor of Science in Geography (BSGeog)','Bachelor of Science in Geology (BSGeol)','Bachelor of Science in Graphic Design (BSGDes)','Bachelor of Science in Healthcare Administration (BSHA)','Bachelor of Science in Healthcare Informatics (BSHI)','Bachelor of Science in Healthcare Management (BSHM)','Bachelor of Science in Healthcare Sciences (BSHS)','Bachelor of Science in History (BSHist)','Bachelor of Science in Hospitality Management (BSHM)','Bachelor of Science in Human Resources Management (BSHRM)','Bachelor of Science in Information Systems (BSIS)','Bachelor of Science in Information Technology (BSIT)','Bachelor of Science in Interior Design (BSIntDes)','Bachelor of Science in International Business (BSIB)','Bachelor of Science in International Relations (BSIR)','Bachelor of Science in Investment Management (BSIM)','Bachelor of Science in Journalism (BSJ)','Bachelor of Science in Landscape Architecture (BSLA)','Bachelor of Science in Lighting Design (BSLDes)','Bachelor of Science in Management (BSMgt)','Bachelor of Science in Management Information Systems (BSMIS)','Bachelor of Science in Marketing (BSM)','Bachelor of Science in Marketing (BSMktg)','Bachelor of Science in Marketing Analytics (BSMA)','Bachelor of Science in Mass Communications (BSMC)','Bachelor of Science in Mathematics (BSMath)','Bachelor of Science in Mathematics Education (BSMathEd)','Bachelor of Science in Media Studies (BSMedia)','Bachelor of Science in Medical Laboratory Science (BSMLS)','Bachelor of Science in Music Education (BSMusicEd)','Bachelor of Science in Music Production (BSMP)','Bachelor of Science in Nursing (BSN)','Bachelor of Science in Nursing Administration (BSNA)','Bachelor of Science in Nutrition (BSNutr)','Bachelor of Science in Occupational Therapy (BSOT)','Bachelor of Science in Physical Education (BSPE)','Bachelor of Science in Physical Therapy (BSPT)','Bachelor of Science in Physics (BSPhys)','Bachelor of Science in Political Science (BSPolS)','Bachelor of Science in Predictive Analytics (BSPA)','Bachelor of Science in Product Management (BSPM)','Bachelor of Science in Psychology (BSPsy)','Bachelor of Science in Public Health (BSPH)','Bachelor of Science in Public Relations (BSPR)','Bachelor of Science in Radio Production (BSRP)','Bachelor of Science in Radiology Technology (BSRT)','Bachelor of Science in Religious Studies (BSRelSt)','Bachelor of Science in Respiratory Therapy (BSRT)','Bachelor of Science in Risk Management and Insurance (BSRMI)','Bachelor of Science in Science Education (BSSciEd)','Bachelor of Science in Secondary Education (BSSecEd)','Bachelor of Science in Set Design (BSSetDes)','Bachelor of Science in Sociology (BSSoc)','Bachelor of Science in Sound Design (BSSoundDes)','Bachelor of Science in Special Education (BSSpEd)','Bachelor of Science in Speech and Language Pathology (BSSLP)','Bachelor of Science in Sports Management (BSSM)','Bachelor of Science in Supply Chain Management (BSSCM)','Bachelor of Science in Sustainable Design (BSSustDes)','Bachelor of Science in Teaching (BST)','Bachelor of Science in Technology Education (BSTechEd)','Bachelor of Science in Television Production (BSTVP)','Bachelor of Science in Textile Design (BSTDes)','Bachelor of Science in Theatre (BSTheat)','Bachelor of Science in Urban Planning (BSUP)','Bachelor of Science in Web Design (BSWebDes)','Bachelor of Social Work (BSW)','Specify Other (Manual Entry)'];
export const graduate_degree_options = ['Master of Applied Behavior Analysis (MABA)','Master of Architecture (MArch)','Master of Arts (MA)','Master of Arts in Teaching (MAT)','Master of Business Administration (MBA)','Master of Computer Science (MCS)','Master of Education (MEd)','Master of Engineering (MEng)','Master of Engineering Management (MEM)','Master of Fine Arts (MFA)','Master of Health Administration (MHA)','Master of Information (MI)','Master of Juridical Science (MJ)','Master of Library and Information Science (MLIS)','Master of Library Science (MLS)','Master of Music (MM)','Master of Public Administration (MPA)','Master of Public Health (MPH)','Master of Public Policy (MPP)','Master of Science (MSc)','Master of Science in Accounting (MSA)','Master of Science in Acoustics (MSA)','Master of Science in Advertising (MSA)','Master of Science in Aerospace Engineering (MSAE)','Master of Science in Agriculture (MSAg)','Master of Science in Analytics (MSA)','Master of Science in Animation (MSA)','Master of Science in Athletic Training (MSAT)','Master of Science in Audio Technology (MSAT)','Master of Science in Bioinformatics (MSB)','Master of Science in Biomedical Engineering (MSBME)','Master of Science in Chemical Engineering (MSChE)','Master of Science in Civil Engineering (MSCE)','Master of Science in Clinical Psychology (MSCP)','Master of Science in Cognitive Psychology (MSCP)','Master of Science in College Counseling and Student Services (MSCCSS)','Master of Science in Communication Studies (MSCS)','Master of Science in Computer Engineering (MSCE)','Master of Science in Construction Management (MSCM)','Master of Science in Criminology (MSC)','Master of Science in Curriculum and Instruction (MSCI)','Master of Science in Data Science (MSDS)','Master of Science in Developmental Psychology (MSDP)','Master of Science in Digital Marketing (MSDM)','Master of Science in E-Learning (MSEL)','Master of Science in Economics (MSE)','Master of Science in Educational Leadership (MSEL)','Master of Science in eLearning and Instructional Design (MSeLID)','Master of Science in Electrical Engineering (MSEE)','Master of Science in Energy Management (MSEM)','Master of Science in Environmental Science (MSES)','Master of Science in Environmental Science and Policy (MSESP)','Master of Science in Film Studies (MSFS)','Master of Science in Finance (MSF)','Master of Science in Financial Engineering (MSFE)','Master of Science in Forensic Psychology (MSFP)','Master of Science in Game Design (MSGD)','Master of Science in Genetics (MSG)','Master of Science in Geography (MSG)','Master of Science in Global Communication (MSGC)','Master of Science in Health Informatics (MSHI)','Master of Science in Higher Education (MSHE)','Master of Science in Hospitality Management (MSHM)','Master of Science in Human Factors and Ergonomics (MSHFE)','Master of Science in Human Resource Management (MSHRM)','Master of Science in Industrial-Organizational Psychology (MSIOP)','Master of Science in Instructional Design (MSID)','Master of Science in Instructional Technology (MSIT)','Master of Science in Interactive Media (MSIM)','Master of Science in International Business (MSIB)','Master of Science in Kinesiology (MSK)','Master of Science in Management (MSM)','Master of Science in Management Information Systems (MSMIS)','Master of Science in Marine Biology (MSMB)','Master of Science in Marketing (MSMkt)','Master of Science in Marriage and Family Therapy (MSMFT)','Master of Science in Mechanical Engineering (MSME)','Master of Science in Media Studies (MSMS)','Master of Science in Mental Health Counseling (MSMHC)','Master of Science in Microbiology (MSM)','Master of Science in Music Technology (MSMT)','Master of Science in Neuroscience (MSNE)','Master of Science in Nursing (MSN)','Master of Science in Nursing Education (MSN-Ed)','Master of Science in Nursing Leadership (MSN-L)','Master of Science in Nursing Practice (MSN-NP)','Master of Science in Nutrition (MSN)','Master of Science in Occupational Therapy (MSOT)','Master of Science in Operations Research (MSOR)','Master of Science in Pharmaceutical Science (MSPS)','Master of Science in Physical Therapy (MSPT)','Master of Science in Project Management (MSPM)','Master of Science in Psychology (MSP)','Master of Science in Public Relations (MSPR)','Master of Science in Radiation Therapy (MSRT)','Master of Science in Radiology (MSR)','Master of Science in Real Estate (MSRE)','Master of Science in Real Estate Development (MSRED)','Master of Science in Rehabilitation Counseling (MSRC)','Master of Science in Renewable Energy (MSRE)','Master of Science in School Counseling (MSSC)','Master of Science in Software Engineering (MSSE)','Master of Science in Speech-Language Pathology (MS-SLP)','Master of Science in Sport Management (MSSM)','Master of Science in Sport Psychology (MSSP)','Master of Science in Student Affairs (MSSA)','Master of Science in Supply Chain Management (MSSCM)','Master of Science in Sustainability (MSS)','Master of Science in Taxation (MST)','Master of Science in Television and Digital Media (MSTDM)','Master of Science in Tourism Management (MSTM)','Master of Science in Urban Design (MSUD)','Master of Social Science (MSS)','Master of Social Work (MSW)','Master of Urban Planning (MUP)','Specify Other (Manual Entry)'];
export const phd_degree_options = ['PhD in Accounting','PhD in Accounting and Finance','PhD in Aerospace Engineering','PhD in Agricultural Economics','PhD in Agricultural Education','PhD in Agricultural Engineering','PhD in Agricultural Sciences','PhD in Agricultural Sciences and Natural Resources','PhD in Animal Science','PhD in Anthropology','PhD in Applied Mathematics','PhD in Applied Physics','PhD in Architecture','PhD in Architecture and Urban Design','PhD in Art Education','PhD in Art History','PhD in Astrophysics','PhD in Atmospheric Sciences','PhD in Automation and Control','PhD in Behavioral Sciences','PhD in Biochemistry','PhD in Biodiversity and Conservation','PhD in Bioinformatics','PhD in Biological Engineering','PhD in Biological Sciences','PhD in Biology','PhD in Biomedical Sciences','PhD in Biostatistics','PhD in Business Administration','PhD in Business and Management','PhD in Business Economics','PhD in Cancer Biology','PhD in Cell Biology','PhD in Ceramic Engineering','PhD in Chemical Engineering','PhD in Chemical Physics','PhD in Chemistry','PhD in Civil and Environmental Engineering','PhD in Civil Engineering','PhD in Clinical Psychology','PhD in Cognitive Neuroscience','PhD in Communication Studies','PhD in Comparative Education','PhD in Comparative Literature','PhD in Computational Science','PhD in Computer Engineering','PhD in Computer Science','PhD in Conservation Biology','PhD in Creative Writing','PhD in Criminology','PhD in Criminology and Criminal Justice','PhD in Cultural Studies','PhD in Dance','PhD in Development Studies','PhD in Earth Sciences','PhD in Ecology','PhD in Ecology and Evolution','PhD in Econometrics','PhD in Economics','PhD in Education','PhD in Education Policy','PhD in Educational Administration','PhD in Electrical and Computer Engineering','PhD in Electrical Engineering','PhD in Electrophysics','PhD in Energy and Environment','PhD in Energy Sciences','PhD in Engineering','PhD in English Literature','PhD in Environmental Chemistry','PhD in Environmental Engineering','PhD in Environmental Sciences','PhD in Environmental Sciences and Policy','PhD in Environmental Studies','PhD in Epidemiology','PhD in Epidemiology and Biostatistics','PhD in Ethnic Studies','PhD in European Studies','PhD in Evolutionary Biology','PhD in Exercise Physiology','PhD in Film Studies','PhD in Genetics','PhD in Geography','PhD in Geological Sciences','PhD in Geology','PhD in Gerontology','PhD in Health Sciences','PhD in History','PhD in History of Science','PhD in Hospitality Management','PhD in Humanities','PhD in Information Science','PhD in Information Technology','PhD in International Relations','PhD in Law','PhD in Linguistics','PhD in Marketing','PhD in Materials Science','PhD in Mathematics','PhD in Mechanical Engineering','PhD in Medical Sciences','PhD in Medicine','PhD in Music','PhD in Neuroscience','PhD in Nursing','PhD in Nutrition','PhD in Operations Research','PhD in Philosophy','PhD in Physical Education','PhD in Physics','PhD in Physics and Astronomy','PhD in Political Science','PhD in Population Studies','PhD in Psychology','PhD in Public Administration','PhD in Public Health','PhD in Religious Studies','PhD in Social Sciences','PhD in Social Work','PhD in Sociology','PhD in Software Engineering','PhD in Statistics','PhD in Supply Chain Management','PhD in Sustainable Development','PhD in Taxation','PhD in Theatre','PhD in Theology','PhD in Urban Planning',"PhD in Women's Studies",'PhD in Zoology','Specify Other (Manual Entry)'];

export const target_role_type_options = [
	{
		id: 'internship',
		title: 'Internship',
		value: 'Internship',
	}, {
		id: 'full_time_position',
		title: 'Full Time Position',
		value: 'Full Time Position'
	}, {
		id: 'contract_position',
		title: 'Contract Position',
		value: 'Contract Position',
	}, {
		id: 'freelancer_position',
		title: 'Freelancer Position',
		value: 'Freelancer Position'
	},
];

export const non_target_school_name_options = [
	{
		id: 1,
		title: 'Yes',
		value: true,
	}, {
		id: 0,
		title: 'No',
		value: false,
	}
];

export const job_time_options = [
	{ id: 11, title: 'ASAP', value: 'asap' },
	{ id: 12, title: '1~3 months', value: '1-3-months' },
	{ id: 13, title: '4+ months', value: '4-months' },
	{ id: 14, title: 'Not looking', value: 'not-looking' },
];

export const resume_experience_options = [
	{ id: 21, title: 'Beginner', value: 'beginner' },
	{ id: 22, title: 'Advanced Beginner', value: 'advanced-beginner' },
	{ id: 23, title: 'Proficient', value: 'proficient' },
	{ id: 24, title: 'Expert', value: 'expert' },
];

export const education_level_pursuing_options = [
	{ id: 25, title: 'High School', value: 'High School' },
	{ id: 26, title: 'Undergraduate', value: 'Undergraduate' },
	{ id: 27, title: 'Graduate', value: 'Graduate' },
	{ id: 28, title: 'PhD', value: 'PhD' },
	{ id: 29, title: 'N/A', value: 'N/A' },
];

export const FEATURES_DESCRIPTION = {
	bullet_generation_tool: {
		description: 'Bullet point <<action>>',
		action: 'generation',
		premiumDescription: 'Unlimited Bullet point generations',
		isUnlimitedForPremium: true
	},
	cover_letter: {
		description: 'Cover <<action>>',
		action: 'letter',
		premiumDescription: 'Unlimited Cover Letter Generations',
		isUnlimitedForPremium: true
	},
	network_tool: {
		description: 'Networking <<action>>',
		action: 'message',
		premiumDescription: 'Unlimited Networking messages',
		isUnlimitedForPremium: true
	},
	resume_upload: {
		description: 'Resume <<action>>',
		action: 'upload',
		premiumDescription: 'Unlimited Resume uploads',
		isUnlimitedForPremium: true
	},
	interview: {
		description: 'Interview<<action>>',
		action: '',
		premiumDescription: 'Unlimited Interviews',
		isUnlimitedForPremium: true
	},
	job_tracker: {
		description: 'Job Tracker Application<<action>>',
		action: '',
		premiumDescription: 'Unlimited Job Tracker Application',
		isUnlimitedForPremium: true
	},
	cold_email: {
		description: 'Cold Email<<action>>',
		action: '',
		premiumDescription: 'Unlimited Cold Emailing',
		isUnlimitedForPremium: true
	},
	find_email: {
		description: 'Find Email<<action>>',
		action: '',
		premiumDescription: 'Unlimited Find Emails',
		isUnlimitedForPremium: true
	},
	auto_apply_v2: {
		description: 'AutoApply <<action>>',
		action: 'credit',
		premiumDescription: 'Unlimited AutoApply credits',
		isUnlimitedForPremium: true
	},
};

export const INTERVIEW_MODE_OPTIONS = {
	starting: 'starting',
	recording: 'recording',
	waiting: 'waiting'
};

export const CREATE_INTERVIEW_TIPS = [
	'Our AI analyzes your responses for content, clarity, and confidence.',
	'Real-time feedback on your answers, just like a real interview.',
	'InterviewAI: Tailoring questions to your industry and role specifics.',
	'Using advanced algorithms to simulate challenging interview scenarios.',
	'Our AI adapts to your responses, offering a dynamic interview experience.',
	'In-depth analysis of verbal and non-verbal cues, enhancing your interview skills.',
	'Powered by AI, designed to challenge and prepare you.',
	'InterviewAI: Learning from your responses to ask better follow-ups.',
	'Mimicking real interview dynamics for a comprehensive preparation.',
	'Balance professionalism with personality - show them who you are.',
	'Research the company and role - showcase your knowledge.',
	'Use specific examples to demonstrate your skills and experience.',
	'Be concise but thorough in your explanations.',
	"Practice active listening - it's key in interviews.",
	'Tailor your experiences to align with the job requirements.',
	'Maintain eye contact and positive body language.',
	'Prepare questions to ask at the end of the interview.',
	'Reflect on your achievements and be ready to discuss them.',
	'Stay calm and composed, even if the question seems tough.',
	'Use the STAR method for behavioral questions: Situation, Task, Action, Result.',
	'Highlight your unique value proposition - what sets you apart.',
	'Be honest about your experiences and skills.',
	'End with a strong closing statement summarizing your fit for the role.',
	'Show enthusiasm and interest in the position and company.',
	"Discuss how you've overcome challenges in past roles.",
	'Explain your thought process when answering problem-solving questions.',
	'Be prepared to discuss industry trends and how they impact the role.',
	'Emphasize your teamwork and collaboration skills.'
];

export const PROGRESS_COLORS = {
	gray: '#ACADAE',
	green: '#2A8176',
	yellow: '#F3894F',
	red: '#EB5757'
};


export const RANGE_OPTIONS = [
	{ title: 'Within 40 miles', id: 6, value: null, isDefault: true },
	{ title: 'Within 5 miles', id: 1, value: 5 },
	{ title: 'Within 10 miles', id: 2, value: 10 },
	{ title: 'Within 25 miles', id: 3, value: 25 },
	{ title: 'Within 50 miles', id: 4, value: 50 },
	{ title: 'Within 100 miles', id: 5, value: 100 },
];

export const INDUSTRY_OPTIONS = [
	{ title: 'Any industry', id: 70, value: null, isDefault: true },
	{ title: 'Skilled Trades', id: 20, value: 20 },
	{ title: 'Customer Service', id: 21, value: 21 },
	{ title: 'Administration', id: 22, value: 22 },
	{ title: 'IT', id: 23, value: 23 },
	{ title: 'Insurance', id: 24, value: 24 },
	{ title: 'Construction', id: 25, value: 25 },
	{ title: 'Accountancy', id: 26, value: 26 },
	{ title: 'PR', id: 27, value: 27 },
	{ title: 'Human Resources', id: 28, value: 28 },
	{ title: 'Catering', id: 29, value: 29 },
	{ title: 'Manufacturing', id: 30, value: 30 },
	{ title: 'Travel', id: 31, value: 31 },
	{ title: 'Animal Care', id: 32, value: 32 },
	{ title: 'Sport and Fitness', id: 33, value: 33 },
	{ title: 'Retail', id: 34, value: 34 },
	{ title: 'Finance', id: 35, value: 35 },
	{ title: 'Policing', id: 36, value: 36 },
	{ title: 'Design', id: 37, value: 37 },
	{ title: 'Banking', id: 38, value: 38 },
	{ title: 'Advertising', id: 39, value: 39 },
	{ title: 'Education', id: 40, value: 40 },
	{ title: 'Logistics', id: 41, value: 41 },
	{ title: 'No Discipline', id: 42, value: 42 },
	{ title: 'Security', id: 43, value: 43 },
	{ title: 'Third Sector', id: 44, value: 44 },
	{ title: 'Business & Consumer Services', id: 45, value: 45 },
	{ title: 'Marketing', id: 46, value: 46 },
	{ title: 'Cleaning', id: 47, value: 47 },
	{ title: 'Hospitality', id: 48, value: 48 },
	{ title: 'Media', id: 49, value: 49 },
	{ title: 'Social Care', id: 50, value: 50 },
	{ title: 'Transportation', id: 51, value: 51 },
	{ title: 'Sales', id: 52, value: 52 },
	{ title: 'Public Sector', id: 53, value: 33 },
	{ title: 'Construction & Skilled Trades', id: 54, value: 54 },
	{ title: 'Management', id: 55, value: 55 },
	{ title: 'Engineering', id: 56, value: 56 },
	{ title: 'Marketing & Advertising', id: 57, value: 57 },
	{ title: 'Science', id: 58, value: 58 },
	{ title: 'Consulting', id: 59, value: 59 },
	{ title: 'Science & Engineering', id: 60, value: 60 },
	{ title: 'Property', id: 61, value: 61 },
	{ title: 'Farming and Agriculture', id: 62, value: 62 },
	{ title: 'Healthcare', id: 63, value: 63 },
	{ title: 'Health', id: 64, value: 64 },
	{ title: 'Arts and Entertainment', id: 65, value: 65 },
	{ title: 'Gig', id: 66, value: 66 },
	{ title: 'Legal', id: 67, value: 67 },
	{ title: 'Military', id: 68, value: 68 },
	{ title: 'Other Professions', id: 69, value: 69 },
];

export const WORK_OPTIONS = [
	{ title: 'Any work setting', id: 9, value: null, isDefault: true },
	{ title: 'In person', id: 7, value: 'in-person' },
	{ title: 'Remote', id: 8, value: 'remote' },
	{ title: 'Hybrid', id: 9, value: 'hybrid' },
];

export const POSTED_OPTIONS = [
	{ title: 'Posted anytime', id: 15, value: null, isDefault: true },
	{ title: 'Last 24 hours', id: 16, value: '24h' },
	{ title: 'Last 5 days', id: 17, value: '5d' },
	{ title: 'Last 10 days', id: 18, value: '10d' },
	{ title: 'Last 30 days', id: 18, value: '30d' },
];

export const SHOPIFY_THEME = {
	product: {
		styles: {
			title: {
				color: '#20d65b'
			},
			button: {
				'font-family': 'Inter, sans-serif',
				'font-weight': '500',
				'font-size': '14px',
				'padding-top': '6px',
				'padding-bottom': '6px',
				':hover': {
					'background-color': '#26746a'
				},
				'background-color': '#2a8176',
				':focus': {
					'background-color': '#26746a'
				},
				'white-space': 'nowrap',
				width: 'fit-content',
				'border-radius': '4px',
				'padding-left': '16px',
				'padding-right': '16px'
			},
			quantityInput: {
				'font-size': '16px',
				'padding-top': '16px',
				'padding-bottom': '16px'
			},
			price: {
				color: '#23df8b'
			},
			compareAt: {
				color: '#23df8b'
			},
			unitPrice: {
				color: '#23df8b'
			}
		},
		contents: {
			img: false,
			title: false,
			price: false
		},
		text: {
			button: 'Add to cart'
		},
		googleFonts: [
			'Inter'
		]
	},
	modalProduct: {
		contents: {
			img: false,
			imgWithCarousel: true,
			button: false,
			buttonWithQuantity: true
		},
		styles: {
			product: {
				'@media (min-width: 601px)': {
					'max-width': '100%',
					'margin-left': '0px',
					'margin-bottom': '0px'
				}
			},
			button: {
				'font-family': 'Inter, sans-serif',
				'font-weight': 'bold',
				'font-size': '16px',
				'padding-top': '16px',
				'padding-bottom': '16px',
				':hover': {
					'background-color': '#26746a'
				},
				'background-color': '#2a8176',
				':focus': {
					'background-color': '#26746a'
				},
				'border-radius': '10px',
				'padding-left': '59px',
				'padding-right': '59px'
			},
			quantityInput: {
				'font-size': '16px',
				'padding-top': '16px',
				'padding-bottom': '16px'
			},
			title: {
				'font-family': 'Helvetica Neue, sans-serif',
				'font-weight': 'bold',
				'font-size': '26px',
				color: '#4c4c4c'
			},
			price: {
				'font-family': 'Helvetica Neue, sans-serif',
				'font-weight': 'normal',
				'font-size': '18px',
				color: '#4c4c4c'
			},
			compareAt: {
				'font-family': 'Helvetica Neue, sans-serif',
				'font-weight': 'normal',
				'font-size': '15.299999999999999px',
				color: '#4c4c4c'
			},
			unitPrice: {
				'font-family': 'Helvetica Neue, sans-serif',
				'font-weight': 'normal',
				'font-size': '15.299999999999999px',
				color: '#4c4c4c'
			}
		},
		googleFonts: [
			'Inter'
		],
		text: {
			button: 'Add to cart'
		}
	},
	option: {},
	cart: {
		styles: {
			button: {
				'font-family': 'Lato, sans-serif',
				'font-weight': 'bold',
				'font-size': '16px',
				'padding-top': '16px',
				'padding-bottom': '16px',
				':hover': {
					'background-color': '#26746a'
				},
				'background-color': '#2a8176',
				':focus': {
					'background-color': '#26746a'
				},
				'border-radius': '10px'
			},
			title: {
				color: '#000000'
			},
			header: {
				color: '#000000'
			},
			lineItems: {
				color: '#000000'
			},
			subtotalText: {
				color: '#000000'
			},
			subtotal: {
				color: '#000000'
			},
			notice: {
				color: '#000000'
			},
			currency: {
				color: '#000000'
			},
			close: {
				color: '#000000',
				':hover': {
					color: '#000000'
				}
			},
			empty: {
				color: '#000000'
			},
			noteDescription: {
				color: '#000000'
			},
			discountText: {
				color: '#000000'
			},
			discountIcon: {
				fill: '#000000'
			},
			discountAmount: {
				color: '#000000'
			}
		},
		text: {
			total: 'Subtotal',
			notice: '',
			button: 'Checkout',
			noteDescription: ''
		},
		contents: {
			note: true
		},
		googleFonts: [
			'Lato'
		]
	},
	toggle: {
		styles: {
			toggle: {
				'font-family': 'Lato, sans-serif',
				'font-weight': 'bold',
				'background-color': '#2a8176',
				':hover': {
					'background-color': '#26746a'
				},
				':focus': {
					'background-color': '#26746a'
				}
			},
			count: {
				'font-size': '16px'
			}
		},
		googleFonts: [
			'Lato'
		]
	},
	lineItem: {
		styles: {
			variantTitle: {
				color: '#000000'
			},
			title: {
				color: '#000000'
			},
			price: {
				color: '#000000'
			},
			fullPrice: {
				color: '#000000'
			},
			discount: {
				color: '#000000'
			},
			discountIcon: {
				fill: '#000000'
			},
			quantity: {
				color: '#000000'
			},
			quantityIncrement: {
				color: '#000000',
				'border-color': '#000000'
			},
			quantityDecrement: {
				color: '#000000',
				'border-color': '#000000'
			},
			quantityInput: {
				color: '#000000',
				'border-color': '#000000'
			}
		}
	}
};

export const INTERVIEW_ROUNDS_ORDER = [
	{
		title: 'Phone Screen',
		description: '~10 min with a Recruiter',
		key: 'phoneScreen',
	},
	{
		title: 'First Round',
		description: '~20 min with a Recruiter',
		key: 'recruiter',
	},
	{
		title: 'Second Round',
		description: '~20 min with a Hiring Manager',
		key: 'manager',
	},
	{
		title: 'Final Round',
		description: '~20 min with a Director',
		key: 'executive',
	}
];

export  const REDIRECT_FROM_SN = [ 
	'instagram',
	'barcelona',
	'linkedin',
	'li app',
	'facebook',
	'fbav',
	'fban',
	'fbios',
	'fbop',
	'fbdv',
	'fbmd',
	'youtube',
	'com.google.android.youtube',
	'youtubeapp',
	'tiktok',
	'musically',
	'bytedancewebview',
	'musical_ly',
	'falcontag'
];

export const locations = [
	'Afghanistan',
	'Albania',
	'Algeria',
	'Andorra',
	'Angola',
	'Antigua & Barbuda',
	'Argentina',
	'Armenia',
	'Australia',
	'Austria',
	'Azerbaijan',
	'Bahamas',
	'Bahrain',
	'Bangladesh',
	'Barbados',
	'Belarus',
	'Belgium',
	'Belize',
	'Benin',
	'Bhutan',
	'Bolivia',
	'Bosnia & Herzegovina',
	'Botswana',
	'Brazil',
	'Brunei',
	'Bulgaria',
	'Burkina Faso',
	'Burundi',
	'Cabo Verde',
	'Cambodia',
	'Cameroon',
	'Canada',
	'Central African Republic',
	'Chad',
	'Chile',
	'China',
	'Colombia',
	'Comoros',
	'Congo',
	'Costa Rica',
	"Côte d'Ivoire",
	'Croatia',
	'Cuba',
	'Cyprus',
	'Czech Republic',
	'Denmark',
	'Djibouti',
	'Dominica',
	'Dominican Republic',
	'DR Congo',
	'Ecuador',
	'Egypt',
	'El Salvador',
	'Equatorial Guinea',
	'Eritrea',
	'Estonia',
	'Eswatini',
	'Ethiopia',
	'Fiji',
	'Finland',
	'France',
	'Gabon',
	'Gambia',
	'Georgia',
	'Germany',
	'Ghana',
	'Greece',
	'Grenada',
	'Guatemala',
	'Guinea',
	'Guinea-Bissau',
	'Guyana',
	'Haiti',
	'Holy See',
	'Honduras',
	'Hungary',
	'Iceland',
	'India',
	'Indonesia',
	'Iran',
	'Iraq',
	'Ireland',
	'Israel',
	'Italy',
	'Jamaica',
	'Japan',
	'Jordan',
	'Kazakhstan',
	'Kenya',
	'Kiribati',
	'Kuwait',
	'Kyrgyzstan',
	'Laos',
	'Latvia',
	'Lebanon',
	'Lesotho',
	'Liberia',
	'Libya',
	'Liechtenstein',
	'Lithuania',
	'Luxembourg',
	'Madagascar',
	'Malawi',
	'Malaysia',
	'Maldives',
	'Mali',
	'Malta',
	'Marshall Islands',
	'Mauritania',
	'Mauritius',
	'Mexico',
	'Micronesia',
	'Moldova',
	'Monaco',
	'Mongolia',
	'Montenegro',
	'Morocco',
	'Mozambique',
	'Myanmar',
	'Namibia',
	'Nauru',
	'Nepal',
	'Netherlands',
	'New Zealand',
	'Nicaragua',
	'Niger',
	'Nigeria',
	'North Korea',
	'North Macedonia',
	'Norway',
	'Oman',
	'Pakistan',
	'Palau',
	'Panama',
	'Papua New Guinea',
	'Paraguay',
	'Peru',
	'Philippines',
	'Poland',
	'Portugal',
	'Qatar',
	'Romania',
	'Russia',
	'Rwanda',
	'Saint Kitts & Nevis',
	'Saint Lucia',
	'Samoa',
	'San Marino',
	'Sao Tome & Principe',
	'Saudi Arabia',
	'Senegal',
	'Serbia',
	'Seychelles',
	'Sierra Leone',
	'Singapore',
	'Slovakia',
	'Slovenia',
	'Solomon Islands',
	'Somalia',
	'South Africa',
	'South Korea',
	'South Sudan',
	'Spain',
	'Sri Lanka',
	'St. Vincent & Grenadines',
	'State of Palestine',
	'Sudan',
	'Suriname',
	'Sweden',
	'Switzerland',
	'Syria',
	'Tajikistan',
	'Tanzania',
	'Thailand',
	'Timor-Leste',
	'Togo',
	'Tonga',
	'Trinidad & Tobago',
	'Tunisia',
	'Turkey',
	'Turkmenistan',
	'Tuvalu',
	'Uganda',
	'Ukraine',
	'United Arab Emirates',
	'United Kingdom',
	'United States',
	'Uruguay',
	'Uzbekistan',
	'Vanuatu',
	'Venezuela',
	'Vietnam',
	'Yemen',
	'Zambia',
	'Zimbabwe'
];

export const FREQUENCY_OPTIONS = [
	'Daily',
	'Weekly',
	'Monthly',
];

export const BEACH_COMUTE_USERS = [
	'ZGFuaUBiZWFjaGNvbW11dGUuY29t',
];

export const jobResultsTabs = {
	search: 'search',
	recommended: 'recommended',
};

export const REQUESTS_CATEGORY = [
	{ value: null, display:'Any' },
	{ value:'missing_company', display:'Missing Company' },
	{ value:'missing_job_posting', display:'Missing Job Posting' }
];

export const REQUESTS_SORT_OPTIONS = [
	{ value:'updated_at', display:'Latest Activity' },
	{ value:'created_at', display:'Date Created' },
	{ value:'votes_count', display:'Most Voted' },
	{ value: null, display:'All' }
];
